import { render } from "./RaumpioniereLogo.vue?vue&type=template&id=23804abc&scoped=true&lang=pug"
import script from "./RaumpioniereLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./RaumpioniereLogo.vue?vue&type=script&setup=true&lang=js"

import "./RaumpioniereLogo.vue?vue&type=style&index=0&id=23804abc&scoped=true&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23804abc"]])

export default __exports__